import { apiClient } from "api/client";

// 사용자 ID 의 알림 목록 조회 (모든 알림)
export async function getNotificationsApi(id) {
  if (!id) return [];
  try {
    const { data } = await apiClient.get("/get/notification", { params: { id } });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error("getNotificationsApi:", e?.message);
    return [];
  }
}

// 미확인 알림만 조회
export async function getUncheckedNotificationsApi(id) {
  if (!id) return [];
  try {
    const { data } = await apiClient.get("/get/notification/unchecked", {
      params: { id },
    });
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error("getUncheckedNotificationsApi:", e?.message);
    return [];
  }
}

// 전체 알림을 확인 처리 (checkDate 채움)
export async function checkAllNotificationsApi(id) {
  if (!id) return false;
  try {
    const { data } = await apiClient.post("/post/notification/check", { id });
    return !!(data && data.success);
  } catch (e) {
    console.error("checkAllNotificationsApi:", e?.message);
    return false;
  }
}
